<template>
	<div class="flex-box">
		<div class="settings-card">
			<el-form :model="form" ref="form" label-width="140px" :rules="rules">
				<el-form-item label="日志存储期限" prop="logRetentionDays">
					<el-input-number
						v-model="form.logRetentionDays"
						:min="365"
						:max="3650"
						placeholder="天数"
					></el-input-number>
					<span class="unit-tip">天</span>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('form')">保存</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					/** 日志存储期限（天），默认 365，最小值 365 */
					logRetentionDays: 365
				},
				rules: {
					logRetentionDays: [
						{ required: true, message: '请输入日志存储期限', trigger: 'blur' },
						{
							type: 'number',
							min: 365,
							message: '日志存储期限不能少于 365 天',
							trigger: 'blur'
						}
					]
				}
			};
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// 暂不调用接口，仅提示
						this.$message.success('保存成功');
					} else {
						return false;
					}
				});
			}
		}
	};
</script>

<style scoped>
	.flex-box {
		display: flex;
		flex-direction: column;
	}
	.settings-card {
		background: #fff;
		padding: 24px;
		border-radius: 4px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
		max-width: 480px;
	}
	.unit-tip {
		margin-left: 8px;
		color: #909399;
		font-size: 14px;
	}
</style>
